import defaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

export default class analyticsConfig extends defaultAnalyticsConfig {
  static cmp = {
    hasPreferenceView: true,
    accountId: 348,
    privacyManagerId: 839003,
    propertyId: 31830,
    wrapperMessaging:
      "https://sp-consent.krzbb.de/unified/wrapperMessagingWithoutDetection.js",
    mmsDomain: "https://zeitung.krzbb.de",
    baseEndpoint: "https://sp-consent.krzbb.de",
    features: {
      ER: false,
      GA: false,
    },
    siteId: 839003,
  };

  static weekliOptions = {
    key: "80DBFC2F-6618-42AA-BE71-EA991C7E8A7E",
    ID: 693,
    config: 461,
    host: "epaper-krzbb.weekli.de",
  };
}



// WEBPACK FOOTER //
// ./clients/swmh-kbb/js/analyticsConfig.js